import type { IWeightedPersona } from '@experiences/interfaces';

export const PRIMARY_FIT_WEIGHT = 1;
export const SECONDARY_FIT_WEIGHT = 0.2;

export const DEFAULT_PERSONA_FIT: IWeightedPersona[] = [
    {
        persona: 'UNKNOWN',
        weight: 0,
    },
];
